module.exports = __webpack_public_path__ + "heat.svg?30013c23455b1dea2c9dd21c69c59e67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/heat.svg
// module id = 93
// module chunks = 0